<div class="document-theme-default">
  <ng-content></ng-content>
</div>
